export const creatorHref = (handle: string): string =>
	`/@${handle.replace(/^@/, "")}`;
